var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 157.23,
    x2: 0,
    y1: 211.23,
    gradientUnits: "userSpaceOnUse",
    id: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C271"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 28,
    cy: 184.55,
    cx: 768.86,
    fill: "url(#0)",
    transform: "matrix(.92857 0 0 .92857-681.94-139.37)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m773.85 193.97l-1.89-1.89c-.259-.259-.574-.389-.945-.389-.371 0-.686.13-.945.389l-9.116 9.13-4.085-4.099c-.259-.259-.574-.389-.945-.389-.371 0-.686.13-.945.389l-1.89 1.89c-.259.259-.389.574-.389.945 0 .37.13.686.389.945l5.03 5.03 1.89 1.89c.259.259.574.389.945.389.37 0 .685-.13.945-.389l1.89-1.89 10.06-10.06c.259-.259.389-.574.389-.945 0-.37-.13-.685-.389-.945",
    fill: "#fff",
    fillOpacity: 0.851,
    transform: "matrix(1.33268 0 0 1.33268-985.46-232.86)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcComplete);
export default __webpack_public_path__ + "static/media/ic_complete.9abaf78a.svg";
export { ForwardRef as ReactComponent };